import { ClockCircleOutlined } from '@ant-design/icons';

import { useIntl } from 'react-intl';

import { useWorkJourneyContext } from '@src/packages/workJourney/contexts';
import type { WorkJourneyForm } from '@src/packages/workJourney/types';

import styles from '../styles.module.less';

interface WorkJourneyUsersProps {
  record: WorkJourneyForm;
}

const WorkJourneyUsers = ({ record }: WorkJourneyUsersProps) => {
  const intl = useIntl();
  const {
    setIsVisibleUsersDrawer,
    setSelectedDrawerUsers,
    setSelectedWorkJourneyId,
    setSelectedMembersDrawerJourney,
  } = useWorkJourneyContext();
  const { members = [], requiredMembers = 0, id, name = '' } = record;
  const assigned = members.length;
  const isPending = assigned < requiredMembers;

  const handleOpenDrawer = () => {
    if (!id) return;

    setIsVisibleUsersDrawer(true);
    setSelectedDrawerUsers(members);
    setSelectedWorkJourneyId(id);
    setSelectedMembersDrawerJourney({
      id,
      name,
      requiredMembers,
    });
  };

  const ariaLabel = intl.formatMessage(
    { id: 'workJourney.users.cell.ariaLabel' },
    { assigned, required: requiredMembers, name },
  );

  return (
    <button
      type="button"
      className={`${styles.usersCell} ${isPending ? styles.usersCellPending : styles.usersCellComplete}`}
      onClick={handleOpenDrawer}
      aria-label={ariaLabel}
    >
      {isPending && <ClockCircleOutlined className={styles.pendingIcon} aria-hidden />}
      <span className={isPending ? styles.pendingUsers : styles.okUsers}>
        {assigned}/{requiredMembers}
      </span>
    </button>
  );
};

export default WorkJourneyUsers;
